import { styled } from "@mui/material/styles";
const ScrollbarWrapper = styled("div", {
  shouldForwardProp: (props) => props !== "offset"
})`
  position: sticky;
  bottom: 0;
  left: ${({ offset }) => `${offset ?? 0}px`};
  width: ${({ offset }) => `calc(100% - ${offset ?? 0}px)`};
  height: 14px;
  background: transparent;
  z-index: 3;
  cursor: pointer;
`;
const ScrollbarControl = styled("div", {
  shouldForwardProp: (prop) => prop !== "isDragging" && prop !== "width"
})(({ theme, isDragging }) => ({
  position: "absolute",
  top: "calc(50% - 4px)",
  height: "8px",
  background: isDragging ? theme.palette.grey[500] : theme.palette.grey[400],
  borderRadius: "100px",
  zIndex: 1,
  "&:hover": {
    background: theme.palette.grey[500]
  }
}));
export {
  ScrollbarControl,
  ScrollbarWrapper
};
